/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeasurementDefinition } from './MeasurementDefinition';
import type { Session } from './Session';
/**
 * 
 * @export
 * @interface Measurement
 */
export interface Measurement {
    /**
     * 
     * @type {number}
     * @memberof Measurement
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Measurement
     */
    definitionId?: number;
    /**
     * 
     * @type {number}
     * @memberof Measurement
     */
    sessionId?: number;
    /**
     * 
     * @type {string}
     * @memberof Measurement
     */
    recording?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Measurement
     */
    data?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Measurement
     */
    created?: Date;
    /**
     * 
     * @type {MeasurementDefinition}
     * @memberof Measurement
     */
    definition?: MeasurementDefinition;
    /**
     * 
     * @type {Session}
     * @memberof Measurement
     */
    session?: Session;
}

/**
 * Check if a given object implements the Measurement interface.
 */
export function instanceOfMeasurement(value: object): value is Measurement {
    return true;
}

export function MeasurementFromJSON(json: any): Measurement {
    return MeasurementFromJSONTyped(json, false);
}

export function MeasurementFromJSONTyped(json: any, ignoreDiscriminator: boolean): Measurement {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'definitionId': json['definitionId'] == null ? undefined : json['definitionId'],
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'recording': json['recording'] == null ? undefined : json['recording'],
        'data': json['data'] == null ? undefined : json['data'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'definition': json['definition'] == null ? undefined : (require('./MeasurementDefinition') as typeof import('./MeasurementDefinition')).MeasurementDefinitionFromJSON(json['definition']),
        'session': json['session'] == null ? undefined : (require('./Session') as typeof import('./Session')).SessionFromJSON(json['session']),
    };
}

export function MeasurementToJSON(json: any): Measurement {
    return MeasurementToJSONTyped(json, false);
}

export function MeasurementToJSONTyped(value?: Measurement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'definitionId': value['definitionId'],
        'sessionId': value['sessionId'],
        'recording': value['recording'],
        'data': value['data'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'definition': (require('./MeasurementDefinition') as typeof import('./MeasurementDefinition')).MeasurementDefinitionToJSON(value['definition']),
        'session': (require('./Session') as typeof import('./Session')).SessionToJSON(value['session']),
    };
}

